/* eslint-disable no-eval */
import { cGame } from "../../cGame";
import { cScene } from "../../cScene";
import { DisplayRect, helper } from "../helper";
import { Module } from "./Module";

export class Layout extends Module {

  init() {
    this.data && this.data.ofs && this.setOfs(this.data.ofs);
    this.data && this.data.origin && this.setOrigin(this.data.origin);
    this.data && this.data.initProps && this.setInitProps(this.data.initProps);
    if (this.data.mask) {
      setTimeout(() => {
        var sc: cScene = this.ref.scene as cScene;
        var maskRef = sc.getByName(String(this.data.mask))
        var m = new Phaser.Display.Masks.BitmapMask(sc, maskRef);
        this.ref.setMask(m);
      }, 1)
    }
  }

  setInitProps(propsObj: any) {
    var a: any
    setTimeout(() => {
      for (a in propsObj) {
        if ((this.ref.scene as cScene).debugMode && a === 'visible') {
          continue
        }
        var s: string = String(propsObj[a])
        if (s.charAt(0) === '=') {
          (this.ref as any)[a] = String(s).substring(1)
        } else {
          (this.ref as any)[a] = Number(s)
        }
      }
    }, 1)

  }

  static parseOfsAxis(s: string, axis:string = 'x'): number {
    if (s && isNaN(Number(s))) {
      if (cGame.current.sceneGlobal) {
        var rect: DisplayRect = helper.getDisplayRect(cGame.current.sceneGlobal)
        s = s.replace('[dispLeft]', String(rect.left))
        s = s.replace('[map]', String(rect.right) + '- 680')
        s = s.replace('[backpack]', String(rect.right) + '- 420')
        s = s.replace('[left]', String(rect.left))
        s = s.replace('[right]', String(rect.right))
        s = s.replace('[center]', axis === 'x' ? String(rect.cx) : String(rect.cy))
      }

      try {
        s = eval(s);
      } catch (e) {
        console.error('Error in eval::', s)
      }
    }
    return Number(s)
  }

  getOfs(s: string): Phaser.Geom.Point {
    var st:string = s ? s : String(this.data.ofs)
    let [xx, yy] = st.split('x')
    return new Phaser.Geom.Point(Layout.parseOfsAxis(xx,'x'), Layout.parseOfsAxis(yy,'y'))
  }

  setOfs(s: string) {
    let p: Phaser.Geom.Point = this.getOfs(s);
    this.ref.setPosition(p.x, p.y)
  }

  setOrigin(s: string) {
    if (!this.ref.setOrigin) return

    let p: Phaser.Geom.Point = this.getOfs(s);
    this.ref.setOrigin(p.x, p.y)
  }

  get ofs(): string {
    return this.ref.x + 'x' + this.ref.y
  }

  getDistance(tg:any):number {
    let p = new Phaser.Geom.Point(this.ref.x,this.ref.y);
    return Phaser.Math.Distance.BetweenPoints(p, new Phaser.Geom.Point(tg.x,tg.y) )
  }

  get origin_y(): number {
    var s = '0x0'
    if (this.data && this.data.ofs) s = this.data.ofs
    return this.getOfs(s).y
  }

  get origin_x(): number {
    var s = '0x0'
    if (this.data && this.data.ofs) s = this.data.ofs
    return this.getOfs(s).x
  }

  get initProps():any{
    return {...this.data.initProps}
  }

}